<template>
  <v-container>
   <v-layout column>
    <h2 class="headline">Speaker form constructor</h2>
    <FormConstructor v-if="isWriteAvailable"/>
  </v-layout>
  </v-container>
</template>

<script>
import FormConstructor from '@/components/shared/EvFormConstructor'
import mixins from '@/utils/mixins'

export default {
  name: 'SpeakersForm',
  mixins: [mixins.isWriteAvailable],
  data () {
    return {
      // DON'T DELETE! need for isWriteAvailable mixin
      scopeForWrite: 'speakers:write'
    }
  },
  components: {
    FormConstructor
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Speakers/Form/index.vue